export default __webpack_public_path__ + "static/media/photo--sm--54.31938b65.jpg";